import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { MaintenanceType } from '@core/interfaces/maintenance-type';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { debounceTime } from 'rxjs/operators';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

const INPUT_FIELD_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => MaintenanceTypeComponent),
  multi: true
};

@Component({
  selector: 'maintenance-type',
  templateUrl: './maintenance-type.component.html',
  providers: [INPUT_FIELD_VALUE_ACCESSOR]
})
export class MaintenanceTypeComponent implements ControlValueAccessor, OnInit {
  @Input() maintenanceTypes: MaintenanceType[] = [];
  @Input() disabled = false;
  @Input() required = true;
  @Input() appearance = 'legacy';

  public fromControl: FormControl = new FormControl(null, [Validators.required]);

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
    this.fromControl.valueChanges
      .pipe(debounceTime(500))
      .subscribe((value) => {
        this.onChange(value);
      });
  }

  async ngOnInit(): Promise<void> {
    this.disabled ? this.fromControl.disable() : this.fromControl.enable();
  }

  onChange: (_: any) => void = () => { };
  onTouched: (_: any) => void = () => { };

  writeValue(maintenanceTypeId: any): void {
    this.fromControl.setValue(maintenanceTypeId);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
